import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DataService } from 'src/app/services/data.service';
import { CountyRecord } from 'src/app/models/countyRecord';

@Component({
  selector: 'app-record-detail',
  templateUrl: './record-detail.component.html',
  styleUrls: ['./record-detail.component.css']
})
export class RecordDetailComponent implements OnInit {
  @Input() data: CountyRecord;
  @Output() changes: EventEmitter<MatCheckboxChange> = new EventEmitter();
  @Output() update: EventEmitter<boolean> = new EventEmitter();

  constructor(private ds: DataService) { }

  ngOnInit() {
  }

  onChange(event: MatCheckboxChange) {
    this.changes.emit(event);
  }

  onUpdateBtnClk() {
    this.update.emit(true);
  }
}
